import {Button, Panel, PanelHeader, SplitCol, SplitLayout, View} from "@vkontakte/vkui";
import MainCatalog from "../catalog/MainCatalog";
import Cart from "../checkout/Cart";
import {Icon24ShoppingCartOutline} from "@vkontakte/icons";
import Sclads from "../catalog/Sclads";
import TakeAPhoto from "../components/TakeAPhoto";
import React from "react";
import {AdaptivityContext} from "../assets/constants";
import axios from "axios";
import FragmentOstatki from "./Ostatki";
import * as constants from "../assets/constants";

class FragmentFavourites extends FragmentOstatki {
    constructor(props) {
        super(props)
        const state = {
            activePanelOstatki: 'favourites_panel',
            current_group_id: '',

        }

        this.state = {
            ...this.state,
            ...state
        }
    }

    hideSclads = () => {
        this.setState({activePanelOstatki: this.state.lastActivePanelOstatki ?? 'favourites_panel'});

    }

    changeCurrentProduct = (id) => {
        console.log(id)
        const body = new FormData()
        body.append('product_id', id)
        axios.post(this.state.base_url + '?app=partnersproducts&act=getProduct', body,
            {
                withCredentials: true
            }
        ).then((response) => {


            if (this.props.current_user.meta.settings.no_deny_firm_fit_club != '1' && !this.state.ostatki_club_mode && response.data.product.is_firm_fit == '1') {
                this.openErrorNoty('Это товар из ассортимента FirmFit Club. Пожалуйста перейдите в каталог FirmFit Club для заказа этих товаров')
                return
            }
            if (response.data.product.units.length === 0) {
                this.openErrorNoty('Не найден справочник единиц измереня для товара "' + response.data.product.name + '". Уведомление о данной ошибке уже отправлено в службу' +
                    ' технической поддержки, наши специалисты уже устраняют ее. Данные обновятся в течение 3 часов', 10000)
                axios.get(this.state.base_url + '?app=partnersproducts&act=sendEmptyUnitsNotice&product_id=' + id,
                    {
                        withCredentials: true,
                        headers: {
                            'Content-Type': 'multipart/form-data',

                        }

                    }
                )

                return
            }

            this.setState({current_product: response.data.product});

            //setTimeout(() =>
            this.setState({lastActivePanelOstatki: this.state.activePanelOstatki});
            if (this.props.current_user.is_application == '2') {
                if (this.state.monitoring_mode) {
                    window.webkit.messageHandlers.takeAPhoto.postMessage('takeAPhoto')
                } else {
                    this.setState({activePanelOstatki: 'sclads_panel'})
                }

            } else {
                this.setState({activePanelOstatki: this.state.monitoring_mode ? 'photo_panel' : 'sclads_panel'});//, 1000);
            }


        })
    }

    render() {
        return <View activePanel={this.state.activePanelOstatki} >


            <Panel id="favourites_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                    <SplitCol width={"25%"}>
                        <MainCatalog base_url={this.state.base_url}
                                     current_user={this.props.current_user}
                                     current_group_id={this.state.current_group_id}
                                     changeCurrentGroup={this.changeCurrentGroup}
                                     changeCurrentProduct={this.changeCurrentProduct}
                                     current_product={this.state.current_product}
                                     parent_product_id={this.state.parent_product_id}
                                     changeParentProductId={this.changeParentProductId}
                                     is_favourites={true}
                                     get_vars={this.props.get_vars}
                                     current_filter={this.props.current_filter}
                                     current_filter_items={this.props.current_filter_items}
                        />

                    </SplitCol>
                    {AdaptivityContext.isMobile ? '' :
                        <SplitCol>
                            <div>
                                <PanelHeader>Корзина</PanelHeader>
                                <Cart user={this.props.current_user}
                                      base_url={this.state.base_url}
                                      refresh={() => this.setState({})}/>

                            </div>
                            <Button before={<Icon24ShoppingCartOutline/>} onClick={() => {
                                this.setActiveModal(null);
                                window.postMessage('goToCart')
                            }} mode="primary" size="l" stretched>
                                Оформить заказ
                            </Button>
                        </SplitCol>}
                </SplitLayout>

            </Panel>

            <Panel id="sclads_panel">
                <SplitLayout>
                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                    <SplitCol width={"50%"}>
                        <Sclads base_url={this.state.base_url}

                                hideSclads={this.hideSclads}
                                club_mode={this.props.ostatki_club_mode}

                                current_club={this.props.current_club}

                                product={this.state.current_product}
                                parent_product_id={this.state.parent_product_id}
                                user={this.props.current_user}
                                refreshState={this.refreshState}
                        />
                    </SplitCol>
                    {AdaptivityContext.isMobile ? '' :
                        <SplitCol>
                            <div>
                                <PanelHeader>Корзина</PanelHeader>
                                <Cart user={this.props.current_user}
                                      base_url={this.state.base_url}
                                      refresh={() => this.setState({})}/>

                            </div>
                        </SplitCol>}
                </SplitLayout>

            </Panel>
            <Panel id="photo_panel">
                <SplitLayout>
                    <SplitCol width={"50%"}>
                        <TakeAPhoto hidePhotos={this.hideSclads} url={this.state.url}
                                    openErrorNoty={this.openErrorNoty}/>
                    </SplitCol>
                </SplitLayout>

            </Panel>

        </View>
    }

}

export default FragmentFavourites